import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root',
})
export class GetFileIconUtilityService {
  // Service for fetching different icon according to the pass file extension

  private mapFileExtensionToIcon = new Map<string, string>([
    ['jpg', 'image'],
    ['jpeg', 'image'],
    ['png', 'image'],
    ['gif', 'image'],
    ['svg', 'image'],
    ['bmp', 'image'],
    ['webp', 'image'],
    ['pdf', 'pdf'],
    ['xls', 'excel'],
    ['ods', 'excel'],
    ['xlsx', 'excel'],
    ['csv', 'excel'],
    ['doc', 'doc'],
    ['docx', 'doc'],
    ['odt', 'doc'],
    ['ppt', 'ppt'],
    ['pptx', 'ppt'],
    ['txt', 'txt'],
    ['zip', 'zip'],
    ['rar', 'zip'],
    ['html', 'html'],
    ['htm', 'html'],
  ]);
  getFileExtension(file: {
    file: File;
    preview: string;
    id?: number;
    name?: string;
    title?: string;
  }): string | undefined {
    const fileName = (() => {
      switch (true) {
        case !!file?.id:
          return file?.preview || file?.name || file?.title;

        default:
          return file?.name;
      }
    })();

    return fileName?.split('.').pop()?.toLowerCase();
  }

  getFileIcon(file: {
    file: File;
    preview: string;
    id?: number;
    name?: string;
    title?: string;
  }): string {
    const fileExtension = this.getFileExtension(file);
    if (fileExtension && this.mapFileExtensionToIcon.has(fileExtension)) {
      const iconBaseName = this.mapFileExtensionToIcon.get(fileExtension);
      const svgPath = `assets/icons/icon-${iconBaseName}.svg`;
      return svgPath;
    }
    return 'assets/icons/icon-file.svg';
  }

  getFilePathExtension(filePath: string): string {
    const fileName = filePath.split('/').pop(); // Get the last part after the last '/'
    if (!fileName) return ''; // Return empty string if fileName is not found

    const extension = fileName.split('.').pop(); // Get the last part after the last '.'
    return extension ? extension.toLowerCase() : ''; // Ensure lowercase and return
  }

  getFileIconByFilePath(filePath: string): string {
    const fileExtension = this.getFilePathExtension(filePath);
    if (fileExtension && this.mapFileExtensionToIcon.has(fileExtension)) {
      const iconBaseName = this.mapFileExtensionToIcon.get(fileExtension);
      const svgPath = `assets/icons/icon-${iconBaseName}.svg`;
      return svgPath;
    }
    return 'assets/icons/icon-file.svg';
  }

  // get file icon based on the mimeType
  getFileTypeFromMime(mimeType: string): string {
    const mimeMap: Record<string, string> = {
      // Images
      'image/jpeg': 'image',
      'image/png': 'image',
      'image/gif': 'image',
      'image/svg+xml': 'image',
      'image/webp': 'image',
      jpeg: 'image',
      png: 'image',
      gif: 'image',
      svg: 'image',
      'svg+xml': 'image',
      webp: 'image',

      // Videos
      'video/mp4': 'video',
      'video/mpeg': 'video',
      'video/webm': 'video',
      'video/ogg': 'video',
      mp4: 'video',
      mpeg: 'video',
      webm: 'video',
      ogg: 'video',

      // Audio
      'audio/mpeg': 'audio',
      'audio/ogg': 'audio',
      'audio/wav': 'audio',
      wav: 'audio',

      // Documents
      'application/pdf': 'pdf',
      'application/msword': 'doc',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        'doc',
      'application/vnd.ms-excel': 'excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        'excel',
        'application/vnd.oasis.opendocument.spreadsheet': 'excel', // .ods files
      'application/vnd.ms-powerpoint': 'ppt',
      'application/vnd.openxmlformats-officedocument.presentationml.presentation':
        'ppt',
       
      pdf: 'pdf',
      msword: 'doc',
      'vnd.openxmlformats-officedocument.wordprocessingml.document': 'doc',
      'vnd.ms-word':'doc',
      'vnd.ms-excel': 'excel',
      'vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'excel',
      'vnd.oasis.opendocument.spreadsheet': 'excel', // .ods files
      'vnd.ms-powerpoint': 'ppt',
      'vnd.openxmlformats-officedocument.presentationml.presentation': 'ppt',
      xlsx: 'excel',
      doc:'doc',
      // Archives
      'application/zip': 'archive',
      'application/x-rar-compressed': 'archive',
      'application/x-7z-compressed': 'archive',
      zip: 'archive',
      'x-rar-compressed': 'archive',
      'x-7z-compressed': 'archive',

      // Text
      'text/plain': 'txt',
      'text/csv': 'txt',
      'text/html': 'txt',
      'application/json': 'txt',
      plain: 'txt',
      csv: 'txt',
      html: 'txt',
      json: 'txt',
    };

    return mimeMap[mimeType]
      ? `assets/icons/icon-${mimeMap[mimeType]}.svg`
      : 'assets/icons/icon-file.svg';
  }
}
